import { BroadcastChannel } from 'broadcast-channel';

// Takes other open tabs into the app when the user logs in from one of them.
//
// Every page loaded while signed in announces it, and pages loaded while signed out (login, forgot password)
// follow the announcement. A separate channel from tabSync, as signed out pages only listen and should not take
// part in its leader election.
const LOGIN_CHANNEL = 'afflo-login-sync';

interface LoginMessage {
  type: 'LOGGED_IN';
}

// Call on pages loaded while signed in
export function announceLogin(): void {
  const channel = new BroadcastChannel<LoginMessage>(LOGIN_CHANNEL);
  channel.postMessage({ type: 'LOGGED_IN' })
    .catch(() => {
      // Ignore, other tabs stay on the login page
    })
    .finally(() => channel.close());
}

// Call on pages loaded while signed out. The root path sends the user to the app now they are signed in, or
// back to a fresh login page if the session ended again in the meantime.
export function followLoginFromOtherTabs(): void {
  const channel = new BroadcastChannel<LoginMessage>(LOGIN_CHANNEL);
  channel.onmessage = (message) => {
    if (message?.type !== 'LOGGED_IN') return;

    channel.close();
    window.location.assign('/');
  };
}
